import httpCommon from "../http-common";

class ScoresDataService{

    addScore(username, score, date){
        var data = {
            "username": username,
            "score": score,
            "date": date,
        }
        return httpCommon.post(`/score`, data);
    }
}

export default new ScoresDataService();